import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  getSubscriptions(args = {}) {
    const { organizationId, limit, skip, model, modelId } = args
    const params = {
      limit,
      skip,
    }
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/${model}/${modelId}/subscriptions`,
      {
        params,
        paramsSerializer(parameters) {
          return qs.stringify(parameters, { arrayFormat: 'brackets' })
        },
      }
    )
  },

  create(organizationId, model, modelId, payload) {
    const url = `/api/v1/organizations/${organizationId}/${model}/${modelId}/subscriptions`
    return HTTP.post(url, payload)
  },

  update(organizationId, subscriptionId, model, modelId, payload) {
    const url = `/api/v1/organizations/${organizationId}/${model}/${modelId}/subscriptions/${subscriptionId}`
    return HTTP.patch(url, payload)
  },

  createBulk(organizationId, model, modelId, accounts) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/${model}/${modelId}/subscriptions/bulk`,
      { operation: 'post', data: accounts }
    )
  },
}
